import * as React from 'react';
import { FootnoteEmphasized } from 'smoothie';

import type {
    NotificationChannel,
    NotificationType,
} from '../types/UserNotificationChannel';
import NotificationsLineItem from './NotificationsLineItem';

interface NotificationsSectionProps {
    title: string;
    type: NotificationType;
    channels: NotificationChannel[];
}

const NotificationsSection = ({
    title,
    type,
    channels,
}: NotificationsSectionProps) => {
    return (
        <>
            <FootnoteEmphasized marginBottom={20}>{title}</FootnoteEmphasized>
            {channels.map((channel) => {
                return (
                    <NotificationsLineItem
                        key={channel}
                        title={title}
                        type={type}
                        channel={channel}
                    />
                );
            })}
        </>
    );
};

export default NotificationsSection;
